import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@core-ui/Components/ui/input';

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onClear: () => void;
  placeholder?: string;
  disabled?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onKeyDown,
  onClick,
  onClear,
  placeholder = 'Search intent...',
  disabled = false,
}) => {
  return (
    <div className="relative w-full">
      {onClick != null ? (
        <button
          data-qa-id="mag-glass-search"
          type="button"
          onClick={onClick}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground cursor-pointer"
          aria-label="Search"
        >
          <Search className="h-4 w-4" />
        </button>
      ) : (
        <Search className="absolute h-4 w-4 left-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" />
      )}
      <Input
        data-qa-id="search-bar"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        className="pl-10 pr-8"
      />
      {value !== '' && (
        <button
          onClick={onClear}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          aria-label="Clear search"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
